export default __webpack_public_path__ + "static/media/web-developer.4a5ed420.jpg";